import React from "react";
import { Form, Select } from "antd";

const ProvincesAndCities = () => {
  const provincesAndCities = {
    تهران: ["تهران"],
  };

  return (
    <Form className="provinces-and-city" layout="vertical">
      <Form.Item className="item" label="استان">
        <Select
          defaultValue={Object.keys(provincesAndCities)[0]}
          options={Object.keys(provincesAndCities).map((province) => ({
            label: province,
            value: province,
          }))}
        />
      </Form.Item>
      <Form.Item className="item" label="شهر">
        <Select
          defaultValue={Object.keys(provincesAndCities)[0]}
          options={Object.keys(provincesAndCities).map((province) => ({
            label: province,
            value: province,
          }))}
        />
      </Form.Item>
    </Form>
  );
};

export default ProvincesAndCities;
